/*eslint complexity: ["error", 38]*/
import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import momencik from '../../../common/momencik';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { ArticleMode } from '../../../common/spdCore/validation/schemas';
import { GetJudgmentExtendedDto } from '../../../common/spdCore/autogenerated/spdApiClient/models';

import { JudgmentPreviewLink } from './JudgmentPreviewLink';

interface JudgmentsForExternalReferralsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  withHistory?: boolean;
  withFilterInColumns?: boolean;
}

export const judgmentForExternalReferralsForGrid = (
  judgment: GetJudgmentExtendedDto,
) => {
  return {
    key: judgment.id,
    values: {
      'judgment.number': (
        <>
          {judgment.active && <>{judgment.number}</>}
          {!judgment.active && (
            <div className="text-decoration-line-through">
              {judgment.number}
            </div>
          )}
        </>
      ),
      'exam.number': judgment?.exam?.number,
      'judgment.judgmentDate': momencik(judgment.judgmentDate),
      'article.description': judgment?.article?.description || ' ',
      'article.mode':
        (judgment?.article?.mode as unknown as ArticleMode) ===
        ArticleMode.Psychologist
          ? 'psycholog'
          : 'lekarz',
      'examined.surname': judgment?.exam?.examined && (
        <>
          {judgment?.exam.examined.surname} {judgment?.exam.examined.firstname}
        </>
      ),
      'examined.pesel':
        judgment?.exam?.examined?.pesel ||
        (judgment?.exam?.examined?.iDCardType || '') +
          ' ' +
          (judgment?.exam?.examined?.iDCardNumber || '') ||
        '',
      'company.name': judgment?.exam?.examPackage?.company?.name || '',
      preview: (
        <>
          {judgment?.active && (
            <JudgmentPreviewLink
              judgmentId={judgment.id}
              engPdfTemplateType={judgment?.article?.engPdfTemplateType}
            />
          )}
        </>
      ),
    },
  };
};

export const JudgmentsForExternalReferralsSearch: React.FC<
  JudgmentsForExternalReferralsSearchProps
> = props => {
  const columns = [
    {
      header: 'Data orzeczenia',
      property: 'judgment.judgmentDate',
      noFilter: true,
    },
    { header: 'Numer', property: 'judgment.number' },
    { header: 'Nr badania', property: 'exam.number' },
    { header: 'Podstawa', property: 'article.description' },
    { header: 'Badany', property: 'examined.surname' },
    { header: 'PESEL / dok.', property: 'examined.pesel' },
    { header: 'Firma', property: 'company.name' },
    {
      header: 'Orzeczenie',
      property: 'preview',
      noSorting: true,
      noFilter: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="judgment.judgmentDate"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak orzeczeń w systemie"
      withHistory={props.withHistory}
      withFilterInColumns={false} //{props.withFilterInColumns}
    />
  );
};
